
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class PDF extends Vue {
  @Prop() private src!: any;
  @Prop() private show!: false;

  protected closeDialog() {
    this.$emit("close");
  }
}
